(function () {
    'use strict';

    a3_cabin_reports.directive('releasableModule', releasableModule);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name releasableModule
    * @restrict E
    * @description
    *    Implementation of releasable Module
    * @example
    *   Usage:
    *   <releasable-module></releasable-module>
    * @ngInject
    */
    function releasableModule(TrainingSessionFactory, $uibModal, $location) {
        function link(scope) {
            scope.Submit = Submit;
            scope.selectedTrainee = selectedTrainee;
            scope.toggleTrainee = toggleTrainee;
            scope.getRemainingCharacters = getRemainingCharacters;
            scope.leftScroll = leftScroll;
            scope.rightScroll = rightScroll;
            scope.validateGrading = validateGrading;
            scope.getTraineeClass = getTraineeClass;
            scope.openTraineeSignature = openTraineeSignature;
            scope.resetSignature = resetSignature;
            scope.close = close;

            var isGround = scope.groundDuty != null && scope.groundDuty != null;
            
            var phaseId = scope.course.SubmittedSessions[0].PhaseId;
            var phase = scope.course.CrewCoursePhases.find(x => x.PhaseId == phaseId);
            scope.settings = phase.ReleaseGrading;
            
            //Collect all trainee sessions that could be released
            var trainees = [];
            scope.course.SubmittedSessions.forEach(function (session) {
                session.TraineesSessions.filter(x => x.CouldBeReleased && !x.NeedsAdditionalRequest && !x.UnderAdditionalTraining && !x.IsStoppedTraineeCourse).forEach(function (traineeSession) {
                    traineeSession.RadioModel = true; //set default realease option true
                    trainees.push(traineeSession);
                });
            });

            if(trainees.length){
                initializeTrainees(trainees, phase);
            }

            scope.phase = phase;
            scope.trainees = trainees;

            function initializeTrainees(trainees, phase){
                scope.selectedTraineeBadge = {
                    crewId: trainees[0].CrewId
                }; 

                // Set Release Grading
                var releaseCompetences = phase.ReleaseGrading.Competences;
                releaseCompetences.forEach(function (competence) { 
                    competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences); 
                    competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences);

                    //Filter out from optional the ones common with mandatory
                    competence.OptionalSub = competence.OptionalSub.filter(c => !competence.MandatorySub.includes(c));
                });

                //Set Trainee Competences
                trainees.forEach(function (traineeSession) {
                    var competences = [];
                    
                    releaseCompetences.forEach(function (competence) {
                        competences.push(JSON.parse(JSON.stringify(competence)));
                    });
                    traineeSession.ReleaseGrading.Competences = competences;
                });

                //Initialize validation
                trainees.forEach(function (traineeSession) {
                    traineeSession.ReleaseGrading.isGradeValid = scope.settings.GradeType == "NotSet";
                    traineeSession.ReleaseGrading.isReleaseGradingValid = scope.settings.Competences.length == 0;
                });

                //For ground: check aircraft visits
                if(isGround && phase.AircraftTypes.length){
                    trainees.forEach(function(trainee){
                        var visitedAircrafts = trainee.AllVisitedAcTypes;
                        
                        var pendingAircrafts = [];
                        phase.AircraftTypes.forEach(function(type){
                            var array = type.split(',');

                            //if arvi requirement is not met
                            if (!array.some(x => visitedAircrafts.includes(x))) {
                                var pendingArviList = [];
                                if (array.length > 1) 
                                {
                                    array.forEach(function(arvi){
                                        pendingArviList.push(arvi);
                                    });
                                }
                                else
                                {
                                    pendingArviList.push(array[0]);
                                }
                                pendingAircrafts.push(pendingArviList);
                            }
                        });

                        trainee.pendingAircrafts = pendingAircrafts;
                        trainee.ShowReleaseWarning = trainee.pendingAircrafts.length>0;
                    });
                }
                scope.showReleaseWarning = trainees.some(x => x.ShowReleaseWarning);
            }

            function selectedTrainee() {   
                
                return function( trainee ) {
                    var showTrainee = false;
                    if (trainee.CrewId === scope.selectedTraineeBadge.crewId){
                        showTrainee = true;
                    }
                    return showTrainee;
                };
            }

            function close() {
                scope.modalInstance.close();
            }

            function toggleTrainee(){
                if(!scope.selectedTraineeBadge.crewId){
                    scope.selectedTraineeBadge.crewId = scope.trainees.find(x => x.RadioModel).CrewId;
                }

                var selectedCrewId = scope.selectedTraineeBadge.crewId;
                var selectedTrainee = scope.trainees.find(x => x.CrewId == selectedCrewId);
                if(selectedTrainee && !selectedTrainee.RadioModel){
                    if(scope.trainees.find(x => x.RadioModel)){
                        scope.selectedTraineeBadge.crewId = scope.trainees.find(x => x.RadioModel).CrewId;
                    }
                    else{
                        scope.selectedTraineeBadge.crewId = null;
                    }
                }
            }

            function getTraineeClass(crewId){
                var textClass="";

                var trainee = scope.trainees.find(x => x.CrewId == crewId);
    
                //Validate Release grading
                var isReleaseGradingValid = trainee.ReleaseGrading.isGradeValid;
                var isReleaseCompetencesValid = trainee.ReleaseGrading.isCompetenceValid;

                if(isReleaseGradingValid && isReleaseCompetencesValid){
                    textClass = "bg-green text-white";
                }
                else{
                    textClass = "bg-amber text-white";
                }
                
                return textClass;
            }


            function Submit() {
                if (!isValidForm()) {
                    scope.modalInstance = $uibModal.open({
                        templateUrl: 'views/Training/dlgSubmitValidation.html',
                        scope: scope,
                        backdrop: 'static',
                        keyboard: false,
                        size: 'lg'
                    });
                }
                else {
                    scope.modalInstance = $uibModal.open({
                        templateUrl: 'views/Training/dlgSign.html',
                        controller: 'ReleaseSignatureModalCtrl',
                        backdrop: 'static',
                        keyboard: false,
                        size: 'md',
                        resolve: {
                            courseId: function () { return scope.course.Id; },
                            isGround: function () { return isGround; },
                            confirmationMsg: function () { return scope.settings.ConfirmationMessage; },
                            requiresInstructorSignature: function () { return scope.settings.InstructorSignature },
                            trainees: function () { return scope.trainees.filter(x => x.RadioModel) },
                            submitRelease: function () { return SubmitRelease; }
                        }
                    });
    
                    scope.modalInstance.result.then(function (result) {
                        if(result.success){
                            $location.path("/");
                        }
                    });
                }                      
            }

            function SubmitRelease(password) {
                 var submittedSessions = {
                    SignaturePassword : password,
                    TraineesSessions : trainees.filter(x => x.RadioModel)
                };

                return TrainingSessionFactory.releaseSession(submittedSessions);
            }

            function validateGrading(trainee){
                trainee.ReleaseGrading.isGradeValid = trainee.ReleaseGrading.Grade != null && trainee.ReleaseGrading.Grade != undefined;
            }

            /**
           * Calculate remaining characters for comment input
           * @param {string} text 
           * @param {number} max 
           */
            function getRemainingCharacters(text, max) {
                if (typeof (text) === "undefined" || text === null) return '';
                if (typeof (max) === "undefined" || max === null || max < 0 || !max) max = 4000;
                var length = text.length;

                return 'characters left: ' + (max - length);
            }

            function setSubCompetenceValues(current) {
                var updated = [];
                var first = parseInt(current[0], 10);
                var last = current[current.length - 1];

                if (first) {
                    for (var i = first; i <= last; i++) {
                        updated.push(i);
                    }
                }
                return updated;
            }

            function leftScroll() {
                document.querySelector('.horizontal-scroll').scrollLeft -= 500;
            }
            
            function rightScroll() {
                document.querySelector('.horizontal-scroll').scrollLeft += 500;
            }

            
            function isValidForm() {
                /*Requirements before split release
                    1. OnLine Mode
                    2. Valid Release Grading
                    3. Trainee Signature
                */

                var selectedTrainee = scope.trainees.find(x => x.CrewId == scope.selectedTraineeBadge.crewId);

                var isValid = false;
                var info = {
                    border: "",
                    icon: "",
                    msg: ""
                };

                if (!window.navigator.onLine) {
                    info = {
                        border: "border-left-red",
                        icon: "fa-warning text-red",
                        msg: "  <strong>Online mode</strong> is required in order to submit a training. <p>Check your connection and try again!</p>",
                    };
                }
                else if(scope.settings.TraineeSignature && scope.trainees.filter(x => x.RadioModel).some(x => !x.Authorized)){

                    if(selectedTrainee && !selectedTrainee.Authorized){
                        info = {
                            border: "border-left-orange",
                            icon: "fa-pencil-square-o text-orange",
                            msg: "<b>" + selectedTrainee.TraineeName + "</b> needs to sign the form!",
                            scrollToTop:false
                        };
                    }
                    else{
                        info = {
                            border: "border-left-orange",
                            icon: "fa-warning text-orange",
                            msg: "All trainees need to sign their forms!",
                            scrollToTop:true
                        };
                    }
                }
                else if (!isGradingValid()) {
                    info = {
                        border: "border-left-orange",
                        icon: "fa-warning text-orange",
                        msg : ""
                    };
                    if(selectedTrainee && !selectedTrainee.ReleaseGrading.isCompetenceValid)  {
                        info.msg = "You need to grade all competences for <b>" + selectedTrainee.TraineeName + "</b> before submitting!"
                    }
                    else if(selectedTrainee && !selectedTrainee.ReleaseGrading.isGradeValid){
                        info.msg = "You need to grade <b>" + selectedTrainee.TraineeName + "</b> before submitting!"
                    }
                    else if(!scope.gradingValidationInfo.isReleaseCompetencesValid || !scope.gradingValidationInfo.isReleaseGradingValid){
                        info.msg = "You need to grade all trainees before submitting!"
                    }
                }
                else {
                    isValid = true;
                }

                scope.info = info;
                return isValid;
            }

            function validateTraineeForm(trainee) {
                /*Requirements before trainee signature
                    1. OnLine Mode
                    2. Valid Trainee Release Grading
                */

                var isValid = false;
                var info = {
                    border: "",
                    icon: "",
                    msg: ""
                };

                if (!window.navigator.onLine) {
                    info = {
                        border: "border-left-red",
                        icon: "fa-warning text-red",
                        msg: "  <strong>Online mode</strong> is required in order to submit a training. <p>Check your connection and try again!</p>",
                    };
                }
                else if (!trainee.ReleaseGrading.isCompetenceValid) {
                    info = {
                        border: "border-left-orange",
                        icon: "fa-warning text-orange",
                        msg : "You need to grade all competences!"
                    };
                }
                else if (!trainee.ReleaseGrading.isGradeValid) {
                    info = {
                        border: "border-left-orange",
                        icon: "fa-warning text-orange",
                        msg : "You need to select an overall grade!"
                    };
                }
                else {
                    isValid = true;
                }

                scope.info = info;
                return isValid;
            }

            function isGradingValid() {
                var isReleaseGradingValid = scope.settings.GradeType == "NotSet";
                var isReleaseCompetencesValid = scope.settings.Competences.length == 0;

                if (!isReleaseGradingValid) isReleaseGradingValid = !scope.trainees.filter(x => x.RadioModel).some(x => !x.ReleaseGrading.isGradeValid);

                if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !scope.trainees.filter(x => x.RadioModel).some(x => !x.ReleaseGrading.isCompetenceValid);

                scope.gradingValidationInfo = {
                    isReleaseGradingValid: isReleaseGradingValid,
                    isReleaseCompetencesValid: isReleaseCompetencesValid,
                };

                return isReleaseGradingValid && isReleaseCompetencesValid;
            }


            function openTraineeSignature(trainee){
                //Enter signature mode : trainee form becomes read-only
                if(!trainee.Authorized){
                    //Trainee can sign only if his form is valid
                    if (!validateTraineeForm(trainee)) {
                        scope.modalInstance = $uibModal.open({
                            templateUrl: 'views/Training/dlgSubmitValidation.html',
                            scope: scope,
                            backdrop: 'static',
                            keyboard: false,
                            size: 'lg'
                        });
                    }
                    else{
                        trainee.Session = {Authorized:false};
                        trainee.Name = trainee.TraineeName;
                        scope.modalInstance = $uibModal.open({
                            templateUrl: 'views/Training/dlgTraineeSignature.html',
                            controller: 'TraineeSignatureModalCtrl',
                            scope: scope,
                            backdrop: 'static',
                            keyboard: false,
                            size: 'md',
                            resolve: {
                                trainee: function () { return trainee; },
                                signatureSuccess: function () { return function(){trainee.Authorized = true}; }
                            }
                        });
                    }
                }
            }

            function resetSignature(trainee){
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Training/dlgResetSignature.html',
                    controller: 'TraineeSignatureModalCtrl',
                    scope: scope,
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        trainee: function () { return trainee; },
                        signatureSuccess: function () { return function(){}; }
                    }
                });

                modalInstance.result.then(function (confirm) {
                    if(confirm){
                        trainee.Authorized = false;
                        trainee.Session.Authorized = false;
                    }
                   
                });
            }
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/Training/releasable-module.tpl.html',
            scope: false,
            link: link
        }
    }

})();
